export class Opened {
  constructor({
    element,
    index,
    rows,
    cols,
    showSpoiler
  }={}) {
    this.element = element || null
    this.index = index || Infinity
    this.rows = rows || null
    this.cols = cols || null
    this.showSpoiler = showSpoiler || false
  }
}


export const OpenerScroller = {
  watch: {
    ['opened.index'](nval, oval) {
      if (nval != oval && nval != Infinity) {
        if (!this.scrollable) return

        this.$nextTick(x => {
          let $showup = $(this.$refs.showup)
          let offset = $showup.offset()
          let $window = $(window)
          let top = $window.scrollTop()
          let e = 10
          let inView = y => y + e >= top && y <= top + $window.height() + e

          if (!(
            inView(offset.top) &&
            inView(offset.top + $showup.outerHeight())
          )) {
            $(document.body).stop().scrollTop(offset.top)
          }
        })
      }
    }
  }
}


export default {
  mixins: [OpenerScroller],
  props: {
    items: {
      type: Array,
      default() { return [] },
    },
    value: {},
    scrollable: { type: Boolean, default: true }
  },

  data() {
    return {
      list: this.items,
      opened: new Opened({ element: this.value })
    }
  },

  mounted() {
    if (this.opened.element !== null) {
      let index = this.list.findIndex(
        x => this.isElement(this.opened.element, x)
      )
      if (index < 0) return

      this.$nextTick(x => {
        this.open(this.opened.element, index)
      })
    }

    $(window).on('resize', e => {
      if (this.opened.index !== Infinity) {
        this.positionShowup(this.opened.index)
      }
    })
  },

  methods: {
    isElement(a, b) {
      return a == b
    },

    isLastLine(index, cols=this.opened.cols) {
      if (cols == null) {
        return false
      }

      let len = this.$refs.elementsList.length
      return index > len - (len % cols) - 1
    },

    open(element, index) {
      this.opened = new Opened({ element: element })
      this.$emit('input', element)

      this.$nextTick(e => {
        this.positionShowup(index)
      })
    },

    close() {
      this.opened = new Opened()
    },

    positionShowup(index) {
      let items = this.$refs.elementsList
      let container = this.$refs.container.getBoundingClientRect()
      let item = items.length > 0
        ? items[0].getBoundingClientRect()
        : { width: 1 }

      let cols = Math.floor(container.width / item.width) || 1
      let rows = Math.ceil(items.length / cols)

      let len = items.length
      let row = Math.ceil((index + 1) / cols)
      index = Math.max(Math.min(
        row * cols,
        len - (len % cols)
      ), 0)
      this.opened.index = index == len ? (index - cols) : index
      this.opened.rows = rows
      this.opened.cols = cols
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/shared/components/alphabet/opener.js